import { useEffect, useState } from 'react';
import { AddProductModal } from './add-product-modal/add-product-modal.component';
import { ProductItem } from './product-item/product-item.component';
import { ProviderStore } from '../../../store/providerStore';
import { style } from './products.module.css';

import { 
  OutlineButton, 
  Text,
  Table,
  TableHeader 
} from '@recargas-dominicanas/core/components';

interface Props {
  providerId: number;
}

export function Products(props: Props) {

  const { providerId } = props;

  const [openAddModal, setOpenAddModal] = useState(false);
  const products = ProviderStore.getProducts(providerId);

  useEffect(() => {
    ProviderStore.fetchProducts(providerId);
  }, []);

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <Text text='Logo'/>
          <Text text='Nombre'/>
          <Text text='Tipo'/>
          <Text text='Beneficio'/>
          <Text text='Clave'/>
          <Text text='Estado'/>
          <Text text='Porcentaje'/>
          <OutlineButton 
            style={style.addButton} 
            text='Agregar producto'
            onClick={() => setOpenAddModal(true)}/>
        </TableHeader>
        <tbody>
          {
            products?.map(product => (
              <ProductItem
                key={product.id} 
                providerId={providerId}
                providerProduct={product}/>
            ))
          }
        </tbody>
      </Table>
      <AddProductModal
        open={openAddModal}
        providerId={providerId}
        onClose={() => setOpenAddModal(false)}/>
    </div>
  );
}
